export enum ShowDimensions {
	'None',
	'Inside',
	'Outside'
}
